import { getVttDataUrl } from "@/utils/subtitle";
import { useState } from "react";

export default function useSubtitles() {
    const [url, setUrl] = useState(null);

    const getSubtitleUrl = async (url) => {
        const vttUrl = await getVttDataUrl(url);
        setUrl(vttUrl);
    };

    return {
        subtitleUrl: url,
        getSubtitleUrl,
    };
}
